import type { DailyStatItem } from '../api/admin-api'

interface DailyStatsTableProps {
  data: DailyStatItem[]
}

function formatDate(dateStr: string): string {
  const date = new Date(dateStr)
  const dayNames = ['일', '월', '화', '수', '목', '금', '토']
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}.${month}.${day} (${dayNames[date.getDay()]})`
}

function formatNumber(num: number): string {
  return num.toLocaleString('ko-KR')
}

export function DailyStatsTable({ data }: DailyStatsTableProps) {
  // 최신 날짜가 위로 오도록 정렬
  const sortedData = [...data].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  )

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              날짜
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              공유
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              생성 요청
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">
              이미지
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {sortedData.map((item) => (
            <tr key={item.date} className="hover:bg-gray-50">
              <td className="px-6 py-3 text-sm text-gray-900">
                {formatDate(item.date)}
              </td>
              <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
                {formatNumber(item.sharedCount)}
              </td>
              <td className="px-6 py-3 text-sm text-gray-600 text-right tabular-nums">
                {formatNumber(item.generationCount)}
              </td>
              <td className="px-6 py-3 text-sm font-medium text-gray-900 text-right tabular-nums">
                {formatNumber(item.imageCount)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
